const OSS_HOST = 'eat-tea.oss-cn-hangzhou.aliyuncs.com'
const qualityStyle = /^q(?:[1-9][0-9]?|100)$/
const imageFileName = /\.(?:jpe?g|png|webp|gif|bmp|tiff?|heic|avif)$/i

export const isOssUrl = (value: string): boolean => {
  try {
    const url = new URL(value)
    return ['https:', 'http:'].includes(url.protocol) && url.hostname === OSS_HOST
  } catch {
    return false
  }
}

// 只处理本项目 OSS，外站 URL、文字和本地预览不截断。
export const ossObjectPath = (value: string): string => {
  if (!isOssUrl(value)) return value
  const path = new URL(value).pathname
  try {
    const decoded = decodeURIComponent(path)
    const separator = decoded.lastIndexOf('/')
    const original = decoded.slice(0, separator)
    // 只还原自有完整图片 URL；原始 key 不裁剪，样式由 Server 决定。
    return qualityStyle.test(decoded.slice(separator + 1)) && imageFileName.test(original)
      ? original
      : decoded
  } catch {
    return path
  }
}

export const ossExpiresAt = (value: string): number => {
  if (!isOssUrl(value)) return 0
  const query = new URL(value).searchParams
  const expires = Number(query.get('Expires')) * 1000
  return query.get('Signature') && Number.isFinite(expires) ? expires : 0
}

const imageFields = new Set([
  'logo',
  'coverImage',
  'classImage',
  'avatar',
  'url',
  'storePhoto',
  'photo',
  'image',
  'imageUrl',
  'pic',
  'headImg',
  'cover',
  'images',
  'medias',
  'urls',
  'objectKeys',
  'licenseImage',
  'premisesImages',
  'idCardFrontImage',
  'idCardBackImage',
  'idCardHandheldImage'
])

export const ossContentForSave = (content: string): string => {
  // 历史纯文本保持原样，只转换 Delta 中的媒体嵌入。
  if (!content.trimStart().startsWith('[')) return content
  try {
    const ops = JSON.parse(content)
    if (!Array.isArray(ops)) return content
    for (const op of ops) {
      if (!op?.insert || typeof op.insert !== 'object') continue
      for (const type of ['image', 'video']) {
        if (typeof op.insert[type] === 'string') {
          op.insert[type] = storedImage(op.insert[type])
        }
      }
    }
    return JSON.stringify(ops)
  } catch (error) {
    if (error instanceof SyntaxError) return content
    throw error
  }
}

const storedImage = (value: string): string => {
  if (/^(blob:|file:)/i.test(value)) throw new Error('图片尚未上传完成，请稍后保存')
  return ossObjectPath(value)
}

// 在请求边界转换副本，不修改编辑表单，也不依赖各页面重复实现。
export const ossPayloadForSave = (value: unknown, goodsContent = false, field = ''): unknown => {
  if (typeof value === 'string') {
    if (field === 'content' && goodsContent) return ossContentForSave(value)
    if (!imageFields.has(field)) return value
    if (value.trimStart().startsWith('[')) {
      try {
        return JSON.stringify(ossPayloadForSave(JSON.parse(value), goodsContent, field))
      } catch (error) {
        if (!(error instanceof SyntaxError)) throw error
      }
    }
    return storedImage(value)
  }
  if (Array.isArray(value)) return value.map((item) => ossPayloadForSave(item, goodsContent, field))
  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, ossPayloadForSave(item, goodsContent, key)])
    )
  }
  return value
}
